import React, { Fragment, useCallback, useState } from 'react'
import { Route, Switch, useParams, withRouter } from 'react-router-dom'

import Button from '../../../components/Button/Button'
import ConfirmationModal from '../../../modules/ConfirmationModal/ConfirmationModal'
import GenericErrorModal from '../../../modules/GenericErrorModal/GenericErrorModal'
import OldTechnicalStaffFormModal from './OldTechnicalStaffFormModal'
import OldTechnicalStaffInviteModal from './OldTechnicalStaffInviteModal'
import TechnicalStaffCard from '../../../components/Cards/TechnicalStaffCard/TechnicalStaffCard'
import { oldPost } from '../../../helpers/requestOld'
import t from '../../../helpers/i18n'
import { useSelector } from 'react-redux'

const OldTeamTechnicalStaffView = withRouter(({ history, team, onStaffChanged }) => {
  const profile = useSelector(state => state.profile)
  const [staffToRemove, setStaffToRemove] = useState()
  const [error, setError] = useState()
  const { teamId } = useParams()

  const handleClose = useCallback(() => {
    history.push("/cm/teams/" + teamId + "/technical_staff")
    onStaffChanged()
  }, [teamId, history, onStaffChanged])

  const handleOpen = useCallback((technicalStaffId) => history.push("/cm/teams/" + teamId + "/technical_staff/" + technicalStaffId), [teamId, history])
  const handleInvite = useCallback(() => history.push("/cm/teams/" + teamId + "/technical_staff/invite"), [teamId, history])

  const handleRemove = useCallback(() => {
    oldPost('/delegate/teams/' + teamId + "/technical_staff/" + staffToRemove.technical_staff_id + '/remove', {})
      .then(() => {
        // TODO: show a toast?
        onStaffChanged()
      })
      .catch(error => setError(error))
      .finally(() => setStaffToRemove(false))
  }, [teamId, staffToRemove, onStaffChanged])

  return (
    <Fragment>
      <div className="-heading">
        <div className="-left overline-label-large-bold">
          {t('titles.Technical_Staff')}
        </div>
        <div className="-center"></div>
        <div className="-right">
          {team?.registerOpen && 
            <>
              {profile.products.BETA &&
                <Button
                  label={t("buttons.Invite")}
                  size="field-sized"
                  type="dark"
                  color="green"
                  icon="SearchIcon"
                  onClick={handleInvite}
                />
              }
              <Button
                label={t("buttons.Add")}
                size="field-sized"
                type="dark"
                color="green"
                icon="GetIcon"
                onClick={() => handleOpen('new')}
              />
            </>
          }
          {!team?.registerOpen && 
            <div className="caption-default-medium">Registro cerrado</div>          
          }
        </div>
      </div>
      <div className="-content">
        {(team && team.technical_staff) && team.technical_staff.map(staff => (
          <TechnicalStaffCard
            key={staff.technical_staff_id}
            firstName={staff.first_name}
            lastName={staff.last_name}
            avatar={staff.avatar}
            type={t("roles.technical_staff." + staff.type)}
            onClick={() => handleOpen(staff.technical_staff_id)}
            onRemove={() => setStaffToRemove(staff)}
          />
        ))}
        {team && team.technical_staff?.length === 0 &&
          <div className="caption-default-medium">No hay personal técnico registrado.</div>        
        }
      </div>

      <Switch>
        <Route exact path="/cm/teams/:teamId/technical_staff/invite">
          <OldTechnicalStaffInviteModal onCloseRequested={handleClose} />
        </Route>
        <Route exact path="/cm/teams/:teamId/technical_staff/:technicalStaffId">
          <OldTechnicalStaffFormModal onCloseRequested={handleClose} />
        </Route>
      </Switch>

      {staffToRemove &&
        <ConfirmationModal
          title={t('titles.Remove_technical_staff')}
          description={t('descriptions.Are_you_sure_you_want_to_remove_from_this_team', (staffToRemove.first_name + " " + staffToRemove.last_name).toUpperCase())}
          actionLabel={'Remove'}
          danger
          onAccepted={handleRemove}
          onCancelled={() => setStaffToRemove(false)}
        />
      }

      {error && <GenericErrorModal error={error} i18nPrefix="OldTeamTechnicalStaffView" onCloseRequested={() => setError(false)} />}
    </Fragment>
  )
})

export default OldTeamTechnicalStaffView